import { AppConstants } from '../app.constants';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {IhaleModel} from '../model/spring-model/ihale.model';
import {TeklifModel} from '../model/spring-model/teklif.model';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class IhaleService {
  date: Date;

  public _ihaleSubject: BehaviorSubject<IhaleModel>;

  constructor(private https: HttpClient, private  authService: AuthenticationService) {
    this._ihaleSubject = <BehaviorSubject<IhaleModel>>new BehaviorSubject(undefined);
  }
  getIhaleSubject() {
    return this._ihaleSubject.asObservable();
  }
  sendIhaleMessage(ihale: IhaleModel) {
      this._ihaleSubject.next(Object.assign({}, ihale));
  }
  getIhaleListesi(): Observable<HttpResponse<IhaleModel[]>> {
  const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ihale';
  return this.https.get<IhaleModel[]>(apiURL,  {observe: 'response', headers: this.authService.getHeader()});
}
  getIhaleListesiByIlanDurum(ihaleDurum: String , page: number , size: number ): Observable<HttpResponse<IhaleModel[]>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ihale/ihaleDurum/' + ihaleDurum + '/page/' + page + '/size/' + size;
    return this.https.get<IhaleModel[]>(apiURL,  {observe: 'response', headers: this.authService.getHeader()});
  }

  getIhaleCountByIhaleDurum(ihaleDurum: String ): Observable<HttpResponse<{count: number; }>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ihale/count/' + ihaleDurum;
    return this.https.get<{count: number; }>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }
  ihaleYayinla(ihale: IhaleModel ): Observable<HttpResponse<IhaleModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ihale/yayinla/';
    return this.https.post<IhaleModel>(apiURL , ihale , {observe: 'response', headers: this.authService.getHeader()});
  }
  removeIhaleS(id: number): Observable<HttpResponse<boolean>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ihale/' + id;
    return this.https.delete<boolean>(apiURL , {observe: 'response', headers: this.authService.getHeader()});
  }
  getIhaleByidS (id: number): Observable<HttpResponse<IhaleModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ihale/' + id;
    return this.https.get<IhaleModel>(apiURL , {observe: 'response', headers: this.authService.getHeader()});
  }
  putIhale (ihale: IhaleModel): Observable<HttpResponse<IhaleModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ihale/' ;
    return this.https.put<IhaleModel>(apiURL , ihale, {observe: 'response', headers: this.authService.getHeader()});
  }
  getTeklifsByIhale(ihaleId: number): Observable<HttpResponse<TeklifModel[]>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'ihale/teklif/' + ihaleId ;
    return this.https.get<TeklifModel[]>(apiURL , {observe: 'response', headers: this.authService.getHeader()});
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/service/ihale.service.ts